module.exports = "<div> <dv-datepicker input-id=\"before\" name=\"before\" ng-model=\"before\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" class=\"dv-table__input dateinputtable\" placeholder=\"{{'VON' | translate}}\"> </dv-datepicker> <dv-datepicker input-id=\"after\" name=\"after\" ng-model=\"after\" ng-attr-placeholder=\"{{'DATE_PLACEHOLDER' | translate}}\" class=\"dv-table__input dateinputtable\" placeholder=\"{{'BIS' | translate}}\"> </dv-datepicker> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/directive/dv-date-range/dv-date-range.html
// module id = wU/Z
// module chunks = 0